// src-dev/ts/components/clients-carousel.ts

export function initClientsCarousel(): void {
    const track = document.getElementById('track');
  
    if (!track) return;
  
    const carousel = new ClientsCarousel(track);
  
    document.querySelectorAll<HTMLButtonElement>('[data-carousel-dir]').forEach(btn => {
      btn.addEventListener('click', () => {
        const direction = parseInt(btn.dataset.carouselDir ?? '0', 10) as 1 | -1;
        carousel.move(direction);
      });
    });
  }
  
  class ClientsCarousel {
    private track: HTMLElement;
    private currentIndex: number = 0;
  
    constructor(track: HTMLElement) {
      this.track = track;
    }
  
    move(direction: 1 | -1): void {
      const items = this.track.querySelectorAll('.cliente-item');
      const totalItems = items.length;
      const visibleItems = this.getVisibleItems();
      const maxIndex = totalItems - visibleItems;
  
      this.currentIndex = Math.min(Math.max(this.currentIndex + direction, 0), maxIndex);
  
      const percentage = -(this.currentIndex * (100 / visibleItems));
      this.track.style.transform = `translateX(${percentage}%)`;
    }
  
    private getVisibleItems(): number {
      const width = window.innerWidth;
      if (width > 900) return 5;
      if (width > 600) return 3;
      return 2;
    }
  }